export default "__VITE_ASSET__4147db06__"